import angular from 'angular';
import documentTypeIcon from './documentTypeIcon';

export default angular
  .module('components.documentTypeIcon', [])
  .component('documentTypeIcon', documentTypeIcon).name;
